import 'ui-core/widgets/slideshow/js/showcase-slideshow';
UX.showcaseSlideshow.defaultOptions = {
    navigationEvent: 'mouseover',
    sliderOptions: {
        responsive: {
            0: {
                autoHeight: true,
            },
            768: {
                autoHeight: false,
            },
        },
    },
};

const init = UX.showcaseSlideshow.init;
UX.showcaseSlideshow.init = options => {
    if (typeof options === 'object') {
        options = {...UX.showcaseSlideshow.defaultOptions, ...options};
    } else {
        options = UX.showcaseSlideshow.defaultOptions;
    }

    init(options);
};
